import * as yup from 'yup';
import docs from './attachments';
import {
  consentimentoDadosSensiveis,
  acessoContraCheque,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const HerdeiroLegalAtivoSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...acessoContraCheque,
    ...dadosSensiveis,
    ...declaracaoVeracidade,
    ...consentimentoAcertoFinanceiro,
    ...docs.HerdeiroLegalAtivoDocs.rules,
    ...aceiteInss,
  });
};

export const HerdeiroLegalAtivoInitialValues = {
  acessoContraCheque: '',
  consentimentoDadosSensiveis: '',
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  declaracaoVeracidade: false,
  ...docs.HerdeiroLegalAtivoDocs.initialValues,
};

export const HerdeiroLegalAtivoDocs = {
  ...docs.HerdeiroLegalAtivoDocs.docs,
};
